import { ColorScale } from '@/theme/colors';

export const lightPalette = {
  primary: {
    light: ColorScale.blue[300],
    main: ColorScale.blue[500],
  },
  secondary: {
    light: ColorScale.gray[300],
    main: ColorScale.gray[500],
  },
  error: {
    light: ColorScale.red[300],
    main: ColorScale.red[500],
    dark: ColorScale.red[700],
  },
  warning: {
    light: ColorScale.yellow[300],
    main: ColorScale.yellow[500],
  },
  info: {
    light: ColorScale.blue[300],
    main: ColorScale.blue[400],
  },
  success: {
    light: ColorScale.green[300],
    main: ColorScale.green[600],
  },
  background: {
    default: ColorScale.mono.white,
    muted: ColorScale.gray[100],
    subtle: ColorScale.gray[50],
    emphasis: ColorScale.gray[600],
    accent: ColorScale.blue[50],
    info: ColorScale.blue[50],
    infoEmphasis: ColorScale.blue[500],
    success: ColorScale.green[50],
    successEmphasis: ColorScale.green[600],
    warn: ColorScale.yellow[50],
    warnEmphasis: ColorScale.yellow[500],
    danger: ColorScale.red[50],
    dangerEmphasis: ColorScale.red[500],
  },
  border: {
    default: ColorScale.gray[200],
    muted: ColorScale.gray[100],
    subtle: ColorScale.gray[50],
    emphasis: ColorScale.gray[700],
    accent: ColorScale.blue[100],
    accentEmphasis: ColorScale.blue[600],
    info: ColorScale.blue[100],
    infoEmphasis: ColorScale.blue[500],
    success: ColorScale.green[100],
    successEmphasis: ColorScale.green[700],
    warn: ColorScale.yellow[100],
    warnEmphasis: ColorScale.yellow[600],
    danger: ColorScale.red[100],
    dangerEmphasis: ColorScale.red[600],
  },
  text: {
    default: ColorScale.mono.black,
    secondary: ColorScale.gray[700],
    muted: ColorScale.gray[700],
    subtle: ColorScale.gray[500],
    accent: ColorScale.blue[500],
    success: ColorScale.green[600],
    warn: ColorScale.yellow[800],
    danger: ColorScale.red[600],
    emphasis: ColorScale.mono.white,
    disabled: ColorScale.mono.disabled,
  },
};
